import io from 'socket.io-client'
import { ApiMessage } from '@/api/api'

import globalConfig from '@/config/index'

import cobrowsingInit from '@/modules/cobrowsing'

export default {
    data() {
        return {
            typingTimeoutId: null,
            flag: false
        }
    },
    created() {
        this.socketEmitListEvents('$on')
    },
    beforeDestroy() {
        this.socketEmitListEvents('$off')
    },
    watch: {
        storeUuid: 'socketInit'
    },
    computed: {
        storeUuid() {
            return this.$store.state.api.uuid
        }
    },
    methods: {
        emitCoBrowsingRequest(val) {
            this.$store.commit('sockets/historyPush', {
                event: 'co-browsing-request',
                socket_id: val.socket_id
            })
            cobrowsingInit(val)
        },
        emitFinishedBranchWorkTime({ socket_id, branch_id }) {
            this.$store.commit('sockets/historyPush', {
                event: 'finished-branch-work-time',
                socket_id: socket_id
            })

            let working_branches_to_chat = this.$store.state.branch.working_branches_to_chat || []
            let findIndex = working_branches_to_chat?.findIndex(id => branch_id === id)

            if (findIndex !== -1) {
                working_branches_to_chat = working_branches_to_chat.splice(findIndex, 1)
                this.$store.commit('branch/setWorkingBranchesToChat', working_branches_to_chat)
            }
        },
        socketEmitListEvents(OnOrOff) {
            for (let key in this.$store.state.sockets.emitList) {
                let method = this.$store.state.sockets.emitList[key]

                this.$root[OnOrOff](this.$store.state.sockets.emitList[key], this[method])
            }
        },

        emitUpdateGuestEmployee(data) {
            this.$store.commit('sockets/historyPush', {
                event: 'update-guest-employee',
                socket_id: data.socket_id
            })

            this.$store.commit('setOperator', data)
        },

        emitSocketGuestRedirect(data) {
            this.$store.commit('sockets/historyPush', {
                event: 'guest-redirect',
                socket_id: data.socket_id
            })
            this.$root.$emit('operatorAction')
            window.location.href = data.redirectUrl
        },
        emitSocketUpdateActiveChatId(data) {
            this.$store.commit('sockets/historyPush', {
                event: 'update-active-chat-id',
                socket_id: data.socket_id
            })
            let name

            if (data.active_chat_id) {
                name = 'effectChatStarted'
            } else {
                name = 'effectChatFinished'

                this.$store.commit('setLocalStorage', ['initStart', false])
                localStorage.setItem(
                    'effectLastChatFinishDay',
                    new Date().toISOString().slice(0, 10)
                )
            }

            this.$root.$emit('triggerEvent', name)

            this.$store.commit('setApiActiveChatId', data.active_chat_id)
        },
        emitSocketRatingRequest(data) {
            this.$store.commit('sockets/historyPush', {
                event: 'rating-request',
                socket_id: data.socket_id
            })
            console.log(
                'ratingFormShowAfterDialogChatSmiles',
                this.$store.getters['dialog/ratingFormShowAfterDialogChatSmiles']
            )
            //if (this.$store.getters['dialog/ratingFormShowAfterDialogChatSmiles']) {
            this.$root.$emit('operatorAction')
            this.$store.commit('dialog/setShowAfterDialogChatSmiles', true)
            this.$store.commit('setRatingLinkId', data.chat_id)
            //}
        },
        emitSocketContactsRequest(data) {
            this.$store.commit('sockets/historyPush', {
                event: 'contacts-request',
                socket_id: data.socket_id
            })
            this.$root.$emit('operatorAction')
            this.$store.commit('dialog/setPersonalView', 'beforeCall')
            this.$store.commit('dialog/setPersonalShow', true)
        },
        emitSocketNeedUpdateWidget(api) {
            this.$store.commit('sockets/historyPush', {
                event: 'need-update-widget',
                socket_id: api.socket_id
            })

            let { reason } = api
            this.init({ reason })
        },
        emitSocketReload(api) {
            const reloadedDate = sessionStorage.getItem('Effect_reloaded'),
                currentDate = +new Date()
            if (reloadedDate && currentDate - reloadedDate < 60000) return
            this.$store.commit('sockets/historyPush', {
                event: 'reload',
                socket_id: api.socket_id
            })
            sessionStorage.setItem('Effect_reloaded', +new Date())
            location.reload()
        },
        emitSocketGetMessage(message) {
            if (message.isPolling) this.$store.commit('chat/messageSend', message)
            //В одной вкладке по полингу получили сообщеНИЯ, в другой вкладке поллинг со смещением по времени, а там уже сообщения не приходили, потому что из первой вкладке запрос что сообщения доставлены, по этому теперь синхронизируем из полинга вкладки
            else this.$store.commit('chat/messageSendNoTabSync', message)

            if (message.from_role_id === 8) return

            if (message.socket_id) {
                this.$store.commit('sockets/historyPush', {
                    event: 'message',
                    socket_id: message.socket_id
                })
            }

            this.$store.commit('chat/setTyping', false)

            this.$root.$emit('operatorAction')
            this.$store.commit('branch/setOnlineNoSend', false)

            if (message.from_user_info && message.from_user_info.id) {
                this.$root.$emit('emitSetSendFirstMessageOperator', message)
            }

            if (message.intent === 'call') {
                return this.$store.commit('actions/setCallOperatorRequest', true)
            }

            if (message.id) {
                ApiMessage.delivered({ message_id: message.id })
            }

            if (message.intent === 'farewell') {
                this.$store.commit('dialog/setShowAfterDialogChatSmiles', true)
                this.$store.commit('setRatingLinkId', message.chat_id)
            }
        },
        socketInit(uuid) {
            if (!uuid) return
            const socket = io.connect(this.$store.state.api.socket_server, {
                autoConnect: true,
                reconnection: true,
                reconnectionAttempts: 30,
                reconnectionDelay: 3000,
                transports: ['websocket'],
                upgrade: false,
                secure: true,
                requestTimeout: 5000,
                query: {
                    uuid: uuid,
                    user: 'guest',
                    socketGroupId: this.$store.state.api.socketGroupId,
                    rand: Math.random()
                }
            })

            try {
                //socket.disconnect()

                socket.on('typing', data => {
                    this.$store.commit('sockets/historyPush', {
                        event: 'typing',
                        socket_id: data.socket_id
                    })

                    clearTimeout(this.typingTimeoutId)

                    this.$store.commit('chat/setTyping', true)

                    this.typingTimeoutId = setTimeout(() => {
                        this.$store.commit('chat/setTyping', false)
                    }, 3000)
                })

                for (let key in this.$store.state.sockets.emitList) {
                    socket.on(key, socketValue => {
                        this.$root.$emit(this.$store.state.sockets.emitList[key], socketValue)
                    })
                }
            } catch (err) {
                return console.log('Сбой на сервере сокетов')
            }
        }
    }
}
